/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MetaDataModel {
    getFixupPrototypeFunction() { return MetaDataModel.fixupPrototype; }

    static newInstance(model: Partial<MetaDataModel>): MetaDataModel {
        let obj = Object.assign(new MetaDataModel(), model);
        MetaDataModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MetaDataModel>): MetaDataModel {
        if (!model) return null;
        return MetaDataModel.newInstance(<MetaDataModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MetaDataModel) {
        if (!obj) return;

        models.MetaDataModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MetaDataModel): boolean {
        Object.setPrototypeOf(obj, MetaDataModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * template tags
     */
    tags: any;

}
